import {FieldTypeKind} from '../../enum/field.type.kind';
import {EntityMananger} from './core.entity.mananger';

export function Virtual(): PropertyDecorator {
    return (target: any, key: string) => {
        const metadata = EntityMananger.getEntityColumn(target.constructor.name, key);

        metadata.columnName = key;
        metadata.columnType = FieldTypeKind.VIRTUAL;
        EntityMananger.registerEntityColumns(target.constructor.name, metadata);

        return;

    };
}
